import { render, staticRenderFns } from "./AircraftDetails.vue?vue&type=template&id=1ff909ba&scoped=true"
import script from "./AircraftDetails.vue?vue&type=script&lang=js"
export * from "./AircraftDetails.vue?vue&type=script&lang=js"
import style0 from "./AircraftDetails.vue?vue&type=style&index=0&id=1ff909ba&prod&module=true&scoped=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "1ff909ba",
  null
  
)

export default component.exports